module.exports = __webpack_public_path__ + "img/avatar.e73f06bc.png";